import { Dropdown } from '@factorialco/factorial-one-react/dist/experimental'
import { Delete } from '@factorialco/factorial-one-react/icons/app'

import i18n from 'modules/core/lib/i18n'

const SectionContentDropdown = ({ onDelete }: { onDelete: () => void }) => {
  return (
    <Dropdown
      items={[
        {
          label: i18n.t('forms.modals.actions.delete'),
          icon: Delete,
          onClick: onDelete,
        },
      ].filter(Boolean)}
    />
  )
}

export default SectionContentDropdown
